<!-- Use only simple css / components to ensure app isn't stuck in case error happens on every page -->
<!-- E.g. -->
<div class="w-error-container">
	<div class="centered">
		<h1>App Error</h1>
		<div class="error push-top">
			@if (latestError(); as latestError) {
			{{ latestError.message }}
			} @else { Unhandled error }
		</div>

		<div class="text-2 push-top">
			{{ contactUsText() }}
		</div>

		<div class="push-top-md">
			<button class="dashboard-button" (click)="goToDashboard()">Go to dashboard</button>
		</div>
		<div class="push-top">
			<a class="clear-cookies-button" (click)="clearCookies()">Clear site cookies</a>
		</div>
	</div>
</div>
